import { EPData } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';
import { EventShare } from '@rsos/reduxDataStore/src/features/eventShare/types';
import { Tag, TagWrapper } from './EventShareAccordionContent.styles';

/**
 * Display labels for `display_config` entries.
 *
 * A Map rather than an object literal because the lookup key comes from the
 * server (`display_config[].name`): plain-object bracket access resolves
 * inherited keys, so a name like `constructor` or `toString` would return a
 * function — truthy, so it defeats the fallback below and React cannot render
 * it. A Map has no prototype chain, so unknown names cleanly return undefined.
 */
const configNameMap = new Map<string, string>([
  ['incident_location', 'Location'],
  ['map', 'Map'],
  ['additional_data', 'Additional Data'],
  ['live_chat', 'Live Chat'],
  ['live_video', 'Live Video'],
  ['live_transcript', 'Call Transcript'],
  ['incident_summary', 'Call Summary'],
  ['call_summary', 'Call Summary'],
  ['call_transcript', 'Call Transcript'],
]);
const DataShared = ({ share }: { share: EventShare }) => {
  return (
    <Box>
      <Box horizontal flow={4} align="center" color="primaryText">
        <EPData height={14} width={14} />
        <Text fontWeight="bold" size="normal">
          Data Shared
        </Text>
      </Box>
      <TagWrapper>
        {share.display_config.map((config, index) => (
          <Tag key={index}>
            <Text size="small">
              {configNameMap.get(config.name) ?? config.name}
            </Text>
          </Tag>
        ))}
      </TagWrapper>
    </Box>
  );
};

export default DataShared;
